<template>
  <v-card flat>
    <v-card-text>
      <v-alert>Not Yet Implemented</v-alert>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    collection: {
      type: Object
    },
    selector: {
      type: String
    },
    params: {
      type: Object
    }
  },
  data() {
    return {}
  }
}
</script>
